


// Cursor Follower
const html = document.querySelector("html");
const cursor = document.querySelector("#cursor");
const links = document.querySelectorAll("a, button, label, .mdc-checkbox");
const speed = .3;

let initCursor = false;
let mouseX = 0;
let mouseY = 0;
let cursorX = 0;
let cursorY = 0;


/**
 * animated cursor movement
 */
function moveCursorAnimated() { 

  let distanceX = mouseX - cursorX;
  let distanceY = mouseY - cursorY;

  cursorX = cursorX + (distanceX * speed);
  cursorY = cursorY + (distanceY * speed);

  cursor.style.left = cursorX + 'px';
  cursor.style.top = cursorY + 'px';

  requestAnimationFrame(animateCursor);
}


/**
 * instant cursor movement
 */
function moveCursorInstant() { 
  cursor.style.left = mouseX + 'px';
  cursor.style.top = mouseY + 'px';
  requestAnimationFrame(moveCursorInstant);
}


/**
 * update Corsor position & visibility
 */
function updateCursor () {
  html.onmousemove = function(e) {
    mouseX = e.clientX;
    mouseY = e.clientY;

    if (!initCursor) {
      cursor.style.opacity = 1;
      initCursor = true;
    }   
  }

  html.onmouseleave = function(e) {
      cursor.style.opacity = 0;
      initCursor = false;
  };
}


/**
 * mouseOver effects
 */
 function hoverEffect(params) {
  for (var i = 0; i < links.length; i++) {
    var selfLink = links[i];

    selfLink.addEventListener("mouseover", function() {
      cursor.style.transform = 'translate(-50%, -50%) scale(1)';
      
    });
    selfLink.addEventListener("mouseout", function() {
      cursor.style.transform = 'translate(-50%, -50%) scale(.3)';
    });
  }

}



/**
 * init
 */
function init () {
  if (window.matchMedia('(pointer: fine)').matches) { // pointer: none, coarse, fine
    moveCursorInstant()
    updateCursor()
    hoverEffect()
  }
}

export default (() => {
  init();
})();